import React from "react";

const YOUTH_ROWS = [["XS", 41, 52, 34], ["S", 43, 56, 36], ["M", 46, 60, 39], ["L", 48, 64, 41], ["XL", 51, 67, 44]];

function TeeDiagram() {
  return (
    <svg viewBox="0 0 220 230" className="w-44 sm:w-52 mx-auto" aria-hidden="true">
      <path d="M70 30 L95 18 Q110 30 125 18 L150 30 L200 62 L178 92 L158 80 L158 215 L62 215 L62 80 L42 92 L20 62 Z" fill="#fff" stroke="#19324A" strokeWidth="3" strokeLinejoin="round" />
      <path d="M95 18 Q110 42 125 18" fill="none" stroke="#19324A" strokeWidth="3" />
      <line x1="66" y1="118" x2="154" y2="118" stroke="#FF6B9D" strokeWidth="3" markerStart="url(#pink)" markerEnd="url(#pink)" />
      <text x="110" y="112" textAnchor="middle" fontSize="14" fontWeight="700" fill="#19324A">A</text>
      <line x1="140" y1="28" x2="140" y2="210" stroke="#4CC9F0" strokeWidth="3" markerStart="url(#blue)" markerEnd="url(#blue)" />
      <text x="128" y="170" textAnchor="middle" fontSize="14" fontWeight="700" fill="#19324A">B</text>
      <line x1="110" y1="24" x2="34" y2="86" stroke="#A78BFA" strokeWidth="3" markerEnd="url(#purple)" />
      <text x="22" y="50" fontSize="13" fontWeight="700" fill="#19324A">D2</text>
      <defs>
        {[["pink", "#FF6B9D"], ["blue", "#4CC9F0"], ["purple", "#A78BFA"]].map(([id, c]) => (
          <marker key={id} id={id} markerWidth="8" markerHeight="8" refX="4" refY="4" orient="auto-start-reverse"><path d="M0 0 L8 4 L0 8 Z" fill={c} /></marker>
        ))}
      </defs>
    </svg>
  );
}

export default function YouthSizeGuide() {
  return (
    <div data-testid="youth-size-guide">
      <div className="bg-white rounded-3xl soft-shadow overflow-hidden">
        <div className="px-5 pt-5 pb-3">
          <h3 className="font-display font-extrabold text-2xl text-[#19324A]">Youth size guide</h3>
          <p className="text-sm text-[#19324A]/60">Kids tees for big adventures.</p>
        </div>
        <table className="w-full text-left" data-testid="youth-size-table">
          <thead className="bg-[#19324A] text-white"><tr>{["Size", "Width (A)", "Length (B)", "Sleeve (D2)"].map((c) => <th key={c} className="px-4 py-3 font-display font-bold text-xs tracking-wider uppercase">{c}</th>)}</tr></thead>
          <tbody>{YOUTH_ROWS.map((r, i) => <tr key={r[0]} className={i % 2 ? "bg-[#4CC9F0]/10" : ""}>{r.map((cell, j) => <td key={j} className={`px-4 py-3 text-[#19324A] text-sm ${j === 0 ? "font-bold" : ""}`}>{cell}</td>)}</tr>)}</tbody>
        </table>
        <p className="px-5 py-4 text-xs text-[#19324A]/70"><strong className="text-[#19324A]">All measurements are in centimetres (cm).</strong><br />Garment measurements taken flat — these are not body measurements.</p>
      </div>

      <div className="mt-5 bg-white rounded-3xl soft-shadow p-5 sm:p-6 grid sm:grid-cols-[auto_1fr] gap-6 items-center" data-testid="youth-how-to-measure">
        <div>
          <TeeDiagram />
          <p className="text-xs font-bold text-[#19324A] text-center mt-1">Measure a tee that fits well.</p>
        </div>
        <div className="space-y-3 text-sm text-[#19324A]/80">
          <h4 className="font-display font-extrabold text-xl text-[#19324A]">How to measure</h4>
          <p><strong className="text-[#19324A]">Start with a favourite tee.</strong> Lay it flat on a level surface. Smooth out creases without stretching the fabric.</p>
          <p><strong className="text-[#19324A]">A | Width</strong> — measure straight across the chest, from armpit to armpit.</p>
          <p><strong className="text-[#19324A]">B | Length</strong> — measure from the top shoulder beside the neck down to the bottom hem.</p>
          <p><strong className="text-[#19324A]">D2 | Sleeve from centre back</strong> — measure from the centre back of the neck, over the shoulder to the sleeve edge.</p>
        </div>
      </div>

      <div className="mt-5 rounded-3xl bg-[#FFD93D] p-5 text-[#19324A]" data-testid="youth-between-sizes">
        <p className="font-bold">Between sizes? <span className="font-normal">Choose the larger size for a roomier fit.</span></p>
        <p className="text-xs mt-1">Compare with the product size guide before ordering.</p>
      </div>
    </div>
  );
}
